import config from "@/libs/config";
import Router from "next/router";

export const ConnectBoardRedirectTopPage = () => {
  const fqdn = config.CONNECT_BOARD_FQDN;

  const url = `https://${fqdn}/`;
  Router.push(url);

  return <></>;
};
